<template>
  <v-container fluid>
    <a-tabs v-model="date" size="small" @change="getdata()">
      <a-tab-pane v-for="item in dates" :key="item" :tab="item"></a-tab-pane>
    </a-tabs>
    <!-- 交接班日志内容 -->
    <v-card tile>
      <a-table size="small" bordered :columns="headers" :data-source="flist" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" row-key="_id">
        <template slot="title">
          <div class="d-flex justify-space-between align-center">
            <span class="text-subtitle-1">
              交接班日志列表（共 {{ list.length }} 条）
            </span>
            <a-space>
              <a-input-search placeholder="搜索内容/提交人" enter-button style="width: 260px" v-model="searchtext" />
              <a-button type="primary" @click="showadd()">
                <a-icon type="plus" /> 新增日志
              </a-button>
            </a-space>
          </div>
        </template>
        <template slot="index" slot-scope="text, record, idx">
          {{ idx + 1 }}
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <a-button type="link" size="small" @click="showedit(record)">
              <a-icon type="edit" /> 编辑
            </a-button>
            <a-popconfirm title="删除数据" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)">
              <a-button type="link" size="small" style="color:#ff4d4f">
                <a-icon type="delete" /> 删除
              </a-button>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </v-card>
    <!-- 新增/编辑线路日志弹窗 -->
    <v-dialog v-model="model" width="600" persistent>
      <v-card>
        <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
          {{ title }}
          <v-icon @click="() => model = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-autocomplete v-model="form.route" :items="routes" outlined dense hide-details clearable>
                  <template v-slot:label>线路<span class="red--text">*</span></template>
                </v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model.number="form.count_30t" type="number" outlined dense hide-details>
                  <template v-slot:label>趟次-30t</template>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="form.finish_30t" outlined dense hide-details>
                  <template v-slot:label>30t完成情况</template>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model.number="form.count_12t" type="number" outlined dense hide-details>
                  <template v-slot:label>趟次-12t</template>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="form.finish_12t" outlined dense hide-details>
                  <template v-slot:label>12t完成情况</template>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="form.remark" outlined rows="2" dense>
                  <template v-slot:label>备注</template>
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn tile color="primary" @click="save">提交</v-btn>
          <v-btn tile @click="() => model = false">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "DispatchLog",
  data() {
    return {
      date: this.$moment().format('YYYY-MM-DD'),
      dates: [
        this.$moment().add(-3, 'day').format('YYYY-MM-DD'),
        this.$moment().add(-2, 'day').format('YYYY-MM-DD'),
        this.$moment().add(-1, 'day').format('YYYY-MM-DD'),
        this.$moment().add(0, 'day').format('YYYY-MM-DD'),
        this.$moment().add(1, 'day').format('YYYY-MM-DD'),
        this.$moment().add(2, 'day').format('YYYY-MM-DD'),
        this.$moment().add(3, 'day').format('YYYY-MM-DD'),
      ],
      searchtext: '',
      list: [],
      headers: [
        { dataIndex: 'route', scopedSlots: { customRender: 'route' }, width: 200, align: 'center', title: '线路' },
        { dataIndex: 'count_30t', scopedSlots: { customRender: 'count_30t' }, width: 120, align: 'center', title: '趟次-30t' },
        { dataIndex: 'finish_30t', scopedSlots: { customRender: 'finish_30t' }, width: 140, align: 'center', title: '30t完成情况' },
        { dataIndex: 'count_12t', scopedSlots: { customRender: 'count_12t' }, width: 120, align: 'center', title: '趟次-12t' },
        { dataIndex: 'finish_12t', scopedSlots: { customRender: 'finish_12t' }, width: 140, align: 'center', title: '12t完成情况' },
        { dataIndex: 'income', scopedSlots: { customRender: 'income' }, width: 140, align: 'center', title: '当日收益（元）' },
        { dataIndex: 'remark', scopedSlots: { customRender: 'remark' }, width: 200, align: 'center', title: '备注' },
      ],
      height: 600,
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      routes: [
        { value: '东线', text: '东线' },
        { value: '西线', text: '西线' },
      ],
      // 交接班日志相关
      model: false,
      title: '',
      form: {},
      valid: true,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    flist() {
      if (!this.searchtext) return this.list;
      return this.list.filter(item =>
        (item.route || '').includes(this.searchtext)
        || (item.remark || '').includes(this.searchtext)
      );
    },
  },
  components: {},
  watch: {
  },
  mounted() {
    this.height = window.innerHeight - 300;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 300;
    };
  },
  activated() {
    this.dates = [
      this.$moment().add(-3, 'day').format('YYYY-MM-DD'),
      this.$moment().add(-2, 'day').format('YYYY-MM-DD'),
      this.$moment().add(-1, 'day').format('YYYY-MM-DD'),
      this.$moment().add(0, 'day').format('YYYY-MM-DD'),
      this.$moment().add(1, 'day').format('YYYY-MM-DD'),
      this.$moment().add(2, 'day').format('YYYY-MM-DD'),
      this.$moment().add(3, 'day').format('YYYY-MM-DD'),
    ];
    this.getdata();
  },
  methods: {
    init() {
      this.getdata();
    },
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchlog/list", { date: this.date }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.form = {
        _id: "",
        route: "",
        count_12t: "",
        finish_12t: "",
        count_30t: "",
        finish_30t: "",
        remark: "",
      };
      this.title = '新增日志';
      this.model = true;
    },
    showedit(item) {
      this.form = {
        _id: item._id,
        route: item.route,
        count_12t: item.count_12t,
        finish_12t: item.finish_12t,
        count_30t: item.count_30t,
        finish_30t: item.finish_30t,
        remark: item.remark,
      };
      this.title = '编辑日志';
      this.model = true;
    },
    save() {
      if (!this.$refs.formRef.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchlog/save", { dataForm: { ...this.form, date: this.date } }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.model = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchlog/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
p {
  margin: 0;
}
</style>